import { useEffect } from 'react';
import config from '../../../../../config';
import SuccessSpan from '../../../../molecules/SuccessSpan';
import WarningSpan from '../../../../molecules/WarningSpan';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { actions } from '../../../../../store/ducks/security/index.duck';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import useGetUserId from '../../../../../hooks/api/useGetUserId';
import { useTranslation } from 'react-i18next';
import { handleBlur, handleFocus } from 'utils/contants';
import { IoIosArrowDown } from 'react-icons/io';

const Schema = Yup.object({
  password: Yup.string().required('Requerido').min(8, 'Debe contener al menos 8 caracteres.'),
  password_confirmation: Yup.string()
    .required('Requerido')
    .when('password', {
      is: (val) => !!(val && val.length > 0),
      then: Yup.string().oneOf([Yup.ref('password')], 'Debe coincidir con la contraseña'),
    }),
});

const loading = (state) => state.security.loading;
const error = (state) => state.security.error;
const status = (state) => state.security.status;

const loadingSelector = () => createSelector(loading, (loading) => loading);

const statusSelector = () => createSelector(status, (status) => status);

const errorSelector = () => createSelector(error, (error) => error);

const ChangePassword = () => {
  const { t } = useTranslation();

  const user_id = useGetUserId();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.clear());
  }, []);

  const loading = useSelector(loadingSelector());
  const status = useSelector(statusSelector());
  const error = useSelector(errorSelector());

  const formik = useFormik({
    initialValues: {
      password: '',
      password_confirmation: '',
    },
    validationSchema: Schema,
    onSubmit: (values) => {
      const payload = { ...values, user_id };
      dispatch(actions.changePass(payload));
    },
  });

  return (
    <div className="container mt-4" id="accordion">
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow  bg-white rounded">
          <div
            className="card-header bg-white d-flex align-items-center justify-content-between"
            id="headingOne"
            style={{
              borderBottom: !config.profile_globant ? '2px solid var(--primary)' : 'none',
              fontWeight: !config.profile_globant ? 600 : 'normal',
            }}
          >
            <span> {t('profile.password_msg')}</span>

            <button
              className="btn"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              <IoIosArrowDown style={{ fontSize: '25px' }} />
            </button>
          </div>
          <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
            <div className="card-block">
              <div className="card-body">
                <div className="form-row">
                  <div className="form-group col-md-6">
                    <label htmlFor="password" className="login__label">
                      <span>{t('profile.password_msg2')} </span>
                    </label>
                    {formik.errors.message ? <WarningSpan msj={formik.errors.message} /> : null}

                    {!error && status ? <SuccessSpan msj={t('profile.password_msg4')} /> : null}
                    <div className="login__input_group">
                      <input
                        id="password"
                        type="password"
                        name="password"
                        className="form-control"
                        {...formik.getFieldProps('password')}
                        autoComplete="new-password"
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                      />
                      {formik.touched.password && formik.errors.password ? (
                        <WarningSpan msj={formik.errors.password} />
                      ) : null}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="password_confirmation" className="login__label">
                      <span>{t('profile.password_msg3')}</span>
                    </label>
                    <div className="login__input_group">
                      <input
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        id="password_confirmation"
                        type="password"
                        name="password_confirmation"
                        className="form-control"
                        {...formik.getFieldProps('password_confirmation')}
                        autoComplete="new-password"
                      />
                      {formik.touched.password_confirmation && formik.errors.password_confirmation ? (
                        <WarningSpan msj={formik.errors.password_confirmation} />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              {loading ? (
                <button className="button" disabled>
                  {t('button.button_msg6')}
                </button>
              ) : (
                <button className="button" type="submit">
                  {t('button.button_msg7')}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
